<script lang="ts">
	import Block from '$components/Block/Block.svelte';
	import { marked } from 'marked';

	// PROPS
	export let text: string;
</script>

<Block id="intro" width="full-width">
	<div class="Intro">
		{@html marked.parse(text)}
	</div>
</Block>

<style lang="scss">
	@use '$styles/mq' as *;
	@use '$styles/colors' as *;

	.Intro {
		padding-top: var(--theme-section-spacing);
		padding-right: 16px;
		padding-left: 16px;
		font-weight: 200;
		font-size: 1.2rem;
		line-height: 1.8;
		font-family: var(--brand-font-copy);
	}

	:global(.Intro p) {
		margin: 0 auto 16px auto;
		max-width: 500px;
		color: var(--theme-secondary);
	}

	:global(#intro) {
		background: var(--theme-primary);
	}
</style>
